import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessModal = ({ isOpen, reference, onClose, onViewShipment }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-elevated max-w-md w-full p-6 animate-fade-in">
        <div className="flex flex-col items-center text-center space-y-4">
          <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center animate-bounce-check">
            <Icon name="CheckCircle" size={32} className="text-success" />
          </div>

          <div>
            <h3 className="text-xl font-semibold text-foreground mb-2">
              Envoi créé avec succès !
            </h3>
            <p className="text-sm text-muted-foreground">
              L'envoi a été enregistré dans le système
            </p>
          </div>

          <div className="w-full bg-primary/5 border border-primary/20 rounded-lg p-4">
            <p className="text-xs text-muted-foreground mb-1">Référence</p>
            <p className="text-2xl font-bold text-primary">{reference}</p>
          </div>

          <div className="flex flex-col sm:flex-row w-full space-y-2 sm:space-y-0 sm:space-x-3 pt-4">
            <Button
              variant="outline"
              onClick={onClose}
              className="w-full sm:w-1/2"
            >
              Fermer
            </Button>
            <Button
              variant="default"
              onClick={onViewShipment}
              iconName="Eye"
              iconPosition="left"
              className="w-full sm:w-1/2"
            >
              Voir l'envoi
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;